import React, { useEffect, useRef, useState } from 'react';
import {
   ChakraProvider,
   Box,
   Input,
   InputGroup,
   InputLeftElement,
   VStack,
   Text,
   Button,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalBody,
   ModalCloseButton,
   Textarea,
   useDisclosure,
   Table,
   Thead,
   Tbody,
   Tr,
   Th,
   Td,
   Badge,
   useColorMode,
   FormControl,
   FormLabel,
   Grid,
   Checkbox,
} from '@chakra-ui/react';
import { Search, Package, FileText, Printer } from 'lucide-react';
import { getBarcodeData, SaveBarcodeData } from '../../../../redux/actions/dashboard';
import { useDispatch, useSelector } from 'react-redux';
import { useUser } from 'contexts';
import JsBarcode from 'jsbarcode';
import { number } from 'zod';

export default function WarrantyForm({ isPrintBarcode, onClose }) {
   const { user } = useUser();
   const dispatch = useDispatch();
   const [searchQuery, setSearchQuery] = useState('');
   const [data, setData] = useState([]);
   const [debouncedSearchQuery, setDebouncedSearchQuery] = React.useState('');
   const [selectedEntry, setSelectedEntry] = useState(null);
   const companyList = useSelector((state) => state.company.list);
   const company = companyList.find((comp) => comp.id === user?.loginhistory?.companyId);
   const [shouldPrint, setShouldPrint] = useState(false);
   const [formData, setFormData] = useState({
      warranty: '',
      conditions: '',
      salesRate: '',
      battery: '',
      notes: '',
      notes2: '',
      notes3: '',
      dealerPrice: '',
      warrantyColor: '',
      conditionsColor: '',
      salesRateColor: '',
      batteryColor: '',
      notesColor: '',
      notes2Color: '',
      notes3Color: '',
      showitemName: true,
      showcompanyName: true,
      itemName: '',
   });

   const { isOpen: isFormOpen, onOpen: onFormOpen, onClose: onFormClose } = useDisclosure();
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   const handleEntryClick = (entry, type) => {
      setSelectedEntry(entry);
      setFormData({
         warranty: entry.specifications ? entry.specifications.warranty : '',
         conditions: entry.specifications ? entry.specifications.conditions : '',
         salesRate: entry.specifications ? entry.specifications.salesRate : '',
         battery: entry.specifications ? entry.specifications.battery : '',
         notes: entry.specifications ? entry.specifications.notes : '',
         notes2: entry.specifications ? entry.specifications.notes2 : '',
         notes3: entry.specifications ? entry.specifications.notes3 : '',
         dealerPrice: entry.specifications ? entry.specifications.dealerPrice : '',
         warrantyColor: entry.specifications ? entry.specifications.warrantyColor : '',
         conditionsColor: entry.specifications ? entry.specifications.conditionsColor : '',
         salesRateColor: entry.specifications ? entry.specifications.salesRateColor : '',
         batteryColor: entry.specifications ? entry.specifications.batteryColor : '',
         notesColor: entry.specifications ? entry.specifications.notesColor : '',
         notes2Color: entry.specifications ? entry.specifications.notes2Color : '',
         notes3Color: entry.specifications ? entry.specifications.notes3Color : '',
         showitemName: true,
         showcompanyName: true,
         itemName: entry.ItemName.length > 35
            ? entry.ItemName.substring(0, 35)
            : entry.ItemName,
      });
      if (type && type === "print") {
         setShouldPrint(true);
      } else {
         onFormOpen();
      }
   };

   const handleInputChange = (field, value) => {
      console.log("input change", field, value);
      setFormData((prev) => ({
         ...prev,
         [field]: value,
      }));
   };

   const handleSave = async (actions = "close") => {
      const saveData = {
         warranty: formData.warranty,
         conditions: formData.conditions,
         salesRate: Number(formData.salesRate),
         battery: formData.battery,
         notes: formData.notes,
         notes2: formData.notes2,
         notes3: formData.notes3,
         dealerPrice: Number(formData.dealerPrice),
         warrantyColor: formData.warrantyColor,
         conditionsColor: formData.conditionsColor,
         salesRateColor: formData.salesRateColor,
         batteryColor: formData.batteryColor,
         notesColor: formData.notesColor,
         notes2Color: formData.notes2Color,
         notes3Color: formData.notes3Color,
         type: selectedEntry.type,
         id: selectedEntry.id,
      };
      console.log('Save Data', saveData);
      const res = await dispatch(SaveBarcodeData(saveData));
      if (res && res.code === 1 && actions === "close") {
         setFormData({
            warranty: '',
            conditions: '',
            salesRate: '',
            battery: '',
            notes: '',
            notes2: '',
            notes3: '',
            dealerPrice: '',
            warrantyColor: '',
            conditionsColor: '',
            salesRateColor: '',
            batteryColor: '',
            notesColor: '',
            notes2Color: '',
            notes3Color: '',
            showitemName: true,
            showcompanyName: true,
            itemName: '',
         });
         setSelectedEntry(null);
         onFormClose();
         console.log("save res", res);
      }
   };

   const executePrintMultiple = (barcodeItems) => {
      const printWindow = window.open('', '_blank', 'height=auto,width=auto');

      let contentHTML = `
<html>
  <head>
    <title>Barcode Labels</title>
    <style>
      @page {
        size: 50mm 25mm;
        margin: 0;
        padding: 0;
      }
      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }
      html, body {
        margin: 0;
        padding: 0;
        width: 50mm;
        height: 25mm;
        overflow: hidden;
      }
      body {
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: Arial, sans-serif;
      }
      .label-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        width: 50mm;
        height: 25mm;
        padding: 1mm;
        margin: 0;
      }
      .barcode-img {
        max-width: 40mm;
        max-height: 10mm;
        width: 70%;
        height: auto;
      }
      .company-logo {
         width: 40px;
         height: 40px;
         object-fit: contain;
         /* margin-bottom: 4px; */
      }
      .serial-number {
        font-size: 6pt;
        text-align: center;
      }
      .companyName {
        font-size: 7pt;
        text-align: center;
        font-weight: bold;
        padding: 0;
        margin-top: 0;
        margin-bottom: 1mm;
      }
      .infogroup {
         display: flex;
         justify-content: center;
         align-items: center;
         gap: 0;
         margin-top: 0mm; /* added space between barcode & info */
      }
      .info {
         width: 35%;
         justify-content: start;
         align-items: start;
         font-size: 7pt;
         text-align: start;
         margin-top: 1mm;
         gap: 0.5mm;
         flex-wrap: nowrap; /* ✅ don't wrap lines */
      }
      .info2 {
         width: 65%;
         justify-content: start;
         align-items: start;
         font-size: 7pt;
         text-align: start;
         margin-top: 1mm;
         gap: 0.5mm;
         flex-wrap: nowrap; /* ✅ don't wrap lines */
      }
      // .info {
      //   font-size: 5pt;
      //   text-align: center;
      //   display: flex;
      //   flex-wrap: wrap;
      //   justify-content: center;
      //   margin-top: 0.5mm;
      //   gap: 0;
      // }
      .itemName {
        font-size: 6pt;
        text-align: center;
        font-weight: bold;
      }
      // .info2 {
      //   font-size: 5pt;
      //   text-align: center;
      //   display: flex;
      //   flex-wrap: wrap;
      //   justify-content: center;
      //   gap: 0;
      // }
      .rate {
        font-size: 6pt;
        text-align: center;
        font-weight: bold;
        margin-top: 1mm;
      }
      .info span {
         display: inline-block;       /* ✅ not flex */
         max-width: 17mm;
         width: 17mm;             /* ✅ set fixed width (adjust as needed) */
         white-space: nowrap;         /* ✅ no line breaks */
         overflow: hidden;            /* ✅ hide overflow */
         text-overflow: ellipsis;     /* ✅ show ... */
         text-align: start;
         margin: 0 0.3mm;
         padding: 0;
         vertical-align: middle;
      }
      .info2 span {
         display: inline-block;       /* ✅ not flex */
         max-width: 31mm;
         width: 31mm;                 /* ✅ set fixed width (adjust as needed) */
         white-space: nowrap;         /* ✅ no line breaks */
         overflow: hidden;            /* ✅ hide overflow */
         text-overflow: ellipsis;     /* ✅ show ... */
         text-align: start;
         margin: 0 0.3mm;
         padding: 0;
         vertical-align: middle;
      }
      .separator {
         width: 0.5mm;
         margin: 0;
         padding: 0;
      }
    </style>
  </head>
  <body>
`;

      const infoData = barcodeItems.infoData || {};
      console.log("infoData", barcodeItems, formData);
      console.log("companyName", barcodeItems.companyName, infoData.showcompanyName);
      contentHTML += `
  <div class="label-container">
    ${barcodeItems.companyName && barcodeItems.companyName !== "null" && infoData.showcompanyName ? `<span class="companyName">${barcodeItems.companyName}</span>` : ''}
    <img class="barcode-img" src="${barcodeItems.barcodeDataUrl}" alt="Barcode" />
    <span class="serial-number">${barcodeItems.barcode}</span>
    <div class="itemName">
       ${infoData.itemName && infoData.showitemName ? `<span>${infoData.itemName}</span>` : ''}
    </div>
    <div class="infogroup">
      <div class="info">
  ${infoData.warranty ? `<span style="color:${infoData.warrantyColor || '#000000'}">W: <strong>${infoData.warranty}</strong></span>` : ''}
  ${infoData.battery ? `<span style="color:${infoData.batteryColor || '#000000'}">B: <strong>${infoData.battery}</strong></span>` : ''}
  ${infoData.conditions ? `<span style="color:${infoData.conditionsColor || '#000000'}">C: <strong>${infoData.conditions}</strong></span>` : ''}
</div>

<div class="info2">
  ${infoData.notes ? `<span style="color:${infoData.notesColor || '#000000'}">N: <strong>${infoData.notes}</strong></span>` : ''}
  ${infoData.notes2 ? `<span style="color:${infoData.notes2Color || '#000000'}">N: <strong>${infoData.notes2}</strong></span>` : ''}
  ${infoData.notes3 ? `<span style="color:${infoData.notes3Color || '#000000'}">N: <strong>${infoData.notes3}</strong></span>` : ''}
</div>
      
    </div>
    <div class="rate">
         ${infoData.salesRate ? `<span style="color:${infoData.salesRateColor || '#000000'}">MRP :- ${infoData.salesRate}</span>` : ''}
      </div>
  </div>
`;

      contentHTML += `
  </body>
</html>
`;
      printWindow.document.write(contentHTML);
      printWindow.document.close();
      setTimeout(() => {
         printWindow.print();
         setTimeout(() => {
            printWindow.close();
         }, 500);
      }, 300);
   };

   const handleBarcodePrint = () => {
      if (selectedEntry.length === 0) return;

      const item = selectedEntry;

      const svgElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      JsBarcode(svgElement, item.serialNo?.toString() ?? '', {
         format: 'CODE128',
         width: 1,
         height: 10,
         displayValue: true,
         fontSize: 0,
         margin: 0,          // ✅ removes all side margins
         marginTop: 0,        // redundant but okay
         marginBottom: 0,     // ensure no space below
         marginLeft: 0,
         marginRight: 0,
         textMargin: 0,
         xmlDocument: document,
      });

      const svgData = new XMLSerializer().serializeToString(svgElement);
      const barcodeDataUrl = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgData);

      const companyLogo = company?.logo
         ? `${company.liveUrl}`
         : '';

      const barcodeItems = {
         serialNumber: item.serialNo,
         dimensions: '6*20 mm',
         barcode: item.barcode,
         barcodeDataUrl: barcodeDataUrl,
         itemName: formData.itemName,
         infoData: formData,
         companyLogo,
         companyName: company?.shortName,
      };

      // setItems(barcodeItems);
      executePrintMultiple(barcodeItems);
   };

   const handleCancel = () => {
      setFormData({
         warranty: '',
         conditions: '',
         salesRate: '',
         battery: '',
         notes: '',
         notes2: '',
         notes3: '',
         dealerPrice: '',
         warrantyColor: '',
         conditionsColor: '',
         salesRateColor: '',
         batteryColor: '',
         notesColor: '',
         notes2Color: '',
         notes3Color: '',
         showitemName: true,
         showcompanyName: true,
         itemName: '',
      });
      onFormClose();
   };

   const debounce = (func, delay) => {
      let timer;
      return function (...args) {
         clearTimeout(timer);
         timer = setTimeout(() => func.apply(this, args), delay);
      };
   };

   const debouncedSearchHandler = React.useCallback(
      debounce((query) => {
         setDebouncedSearchQuery(query);
      }, 500),
      [],
   );

   const handleSearchChange = (value) => {
      setSearchQuery(value);

      debouncedSearchHandler(value);
   };

   const handleClose = () => {
      setData([]);
      setDebouncedSearchQuery("");
      setSearchQuery("");
      onClose();
   };

   useEffect(() => {
      const fetchData = async () => {
         if (isPrintBarcode && debouncedSearchQuery) {
            setData([]);
            const payloadData = {
               companyId: user?.loginhistory?.companyId,
               serialNo: debouncedSearchQuery,
            };
            const res = await dispatch(getBarcodeData(payloadData));
            console.log("res", res);
            if (res && res.code === 1) {
               setData(res.data);
            } else {
               setData([]);
            }
         }
      };

      fetchData();
   }, [debouncedSearchQuery, isPrintBarcode, user, dispatch]);

   useEffect(() => {
      if (shouldPrint) {
         handleBarcodePrint();
         setShouldPrint(false);
      }
   }, [formData, shouldPrint]);

   const saveNprintRef = useRef(null);
   const saveRef = useRef(null);
   const printRef = useRef(null);
   const cancelRef = useRef(null);

   return (
      <>
         {/* Search Modal */}
         <Modal isOpen={isPrintBarcode} onClose={handleClose} size="6xl">
            <ModalOverlay className="backdrop-blur-md bg-black/70" />
            <ModalContent
               className={`rounded-2xl shadow-2xl border-2 transition-all duration-300 ${isDark
                  ? 'bg-gray-800/95 backdrop-blur-xl border-gray-700/50'
                  : 'bg-white/95 backdrop-blur-xl border-gray-200/50'
                  }`}>
               <ModalHeader
                  className={`rounded-t-2xl border-b-2 ${isDark
                     ? 'bg-gradient-to-r from-purple-900/50 to-blue-900/50 border-purple-800/40 text-white'
                     : 'bg-gradient-to-r from-purple-50 to-blue-50 border-purple-200/60 text-gray-900'
                     } py-6 px-8`}>
                  <div className="flex items-center gap-4">
                     <div
                        className={`p-3 rounded-xl transition-all duration-300 ${isDark
                           ? 'bg-gradient-to-br from-purple-900/50 to-blue-900/40 border-2 border-purple-700/50 shadow-lg shadow-purple-900/30'
                           : 'bg-gradient-to-br from-purple-50 to-blue-50 border-2 border-purple-300/50 shadow-md shadow-purple-200/50'
                           }`}>
                        <Search className={`w-6 h-6 ${isDark ? 'text-purple-400' : 'text-purple-600'}`} />
                     </div>
                     <div>
                        <Text className={`text-2xl font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>
                           Search Entry
                        </Text>
                        <Text className={`text-sm mt-1 ${isDark ? 'text-purple-300' : 'text-purple-700'}`}>
                           Find entries by serial number
                        </Text>
                     </div>
                  </div>
               </ModalHeader>
               <ModalCloseButton
                  className={`rounded-xl transition-all duration-300 hover:scale-110 ${isDark ? 'text-gray-400 hover:bg-gray-700/70' : 'text-gray-600 hover:bg-gray-100'
                     }`}
               />
               <ModalBody className="py-8 px-8">
                  <VStack spacing={6} align="stretch">
                     <InputGroup size="lg" className="relative group">
                        <InputLeftElement className="pointer-events-none pl-4">
                           <Search
                              className={`w-5 h-5 transition-colors ${searchQuery
                                 ? isDark
                                    ? 'text-purple-400'
                                    : 'text-purple-600'
                                 : isDark
                                    ? 'text-gray-500'
                                    : 'text-gray-400'
                                 }`}
                           />
                        </InputLeftElement>
                        <Input
                           placeholder="Search by Serial Number..."
                           value={searchQuery}
                           onChange={(e) => handleSearchChange(e.target.value)}
                           className={`rounded-xl border-2 transition-all duration-300 ${isDark
                              ? 'bg-gray-700/70 border-gray-600/80 text-white placeholder-gray-400 hover:border-purple-500/70 focus:border-purple-500/70 focus:bg-gray-700 focus:ring-4 focus:ring-purple-900/30'
                              : 'bg-white border-gray-300 text-gray-900 placeholder-gray-500 hover:border-purple-400/70 focus:border-purple-500/70 focus:ring-4 focus:ring-purple-200/50 shadow-sm'
                              } pl-12 py-3 text-base focus:outline-none`}
                        />
                     </InputGroup>

                     {data.length > 0 && debouncedSearchQuery !== '' ? (
                        <div
                           className={`rounded-xl overflow-hidden border-2 ${isDark ? 'border-gray-700/50 bg-gray-800/50' : 'border-gray-200/50 bg-white/80'
                              } shadow-xl`}>
                           <div className="max-h-96 overflow-y-auto">
                              <Table variant="simple" className="w-full">
                                 <Thead
                                    className={`sticky top-0 z-10 ${isDark
                                       ? 'bg-gradient-to-r from-gray-800 to-gray-800/95 backdrop-blur-sm'
                                       : 'bg-gradient-to-r from-purple-50 to-blue-50/50 backdrop-blur-sm'
                                       }`}>
                                    <Tr>
                                       <Th
                                          className={`font-bold py-4 border-b-2 ${isDark
                                             ? 'text-purple-400 border-gray-700/50'
                                             : 'text-purple-700 border-purple-200/50'
                                             }`}>
                                          Serial Number
                                       </Th>
                                       <Th
                                          className={`font-bold py-4 border-b-2 ${isDark
                                             ? 'text-purple-400 border-gray-700/50'
                                             : 'text-purple-700 border-purple-200/50'
                                             }`}>
                                          Doc No
                                       </Th>
                                       <Th
                                          className={`font-bold py-4 border-b-2 ${isDark
                                             ? 'text-purple-400 border-gray-700/50'
                                             : 'text-purple-700 border-purple-200/50'
                                             }`}>
                                          Transaction Date
                                       </Th>
                                       <Th
                                          className={`font-bold py-4 border-b-2 ${isDark
                                             ? 'text-purple-400 border-gray-700/50'
                                             : 'text-purple-700 border-purple-200/50'
                                             }`}>
                                          Daybook Name
                                       </Th>
                                       <Th
                                          className={`font-bold py-4 border-b-2 ${isDark
                                             ? 'text-purple-400 border-gray-700/50'
                                             : 'text-purple-700 border-purple-200/50'
                                             }`}>
                                          Account Name
                                       </Th>
                                       <Th
                                          className={`font-bold py-4 border-b-2 ${isDark
                                             ? 'text-purple-400 border-gray-700/50'
                                             : 'text-purple-700 border-purple-200/50'
                                             }`}>
                                          Item Name
                                       </Th>
                                       <Th
                                          className={`font-bold py-4 border-b-2 ${isDark
                                             ? 'text-purple-400 border-gray-700/50'
                                             : 'text-purple-700 border-purple-200/50'
                                             }`}>
                                          Amount
                                       </Th>
                                       <Th
                                          className={`font-bold py-4 border-b-2 ${isDark
                                             ? 'text-purple-400 border-gray-700/50'
                                             : 'text-purple-700 border-purple-200/50'
                                             }`}>
                                          Entry Type
                                       </Th>
                                       <Th
                                          className={`font-bold py-4 border-b-2 ${isDark
                                             ? 'text-purple-400 border-gray-700/50'
                                             : 'text-purple-700 border-purple-200/50'
                                             }`}>
                                          Action
                                       </Th>
                                    </Tr>
                                 </Thead>
                                 <Tbody className={`divide-y ${isDark ? 'divide-gray-700/50' : 'divide-gray-100'}`}>
                                    {data.map((entry) => (
                                       <Tr
                                          key={entry.id}
                                          className={`transition-all duration-200 group ${isDark
                                             ? 'hover:bg-gradient-to-r hover:from-purple-900/20 hover:to-blue-900/10 cursor-pointer'
                                             : 'hover:bg-gradient-to-r hover:from-purple-50/50 hover:to-blue-50/30 cursor-pointer'
                                             }`}
                                          onClick={() => handleEntryClick(entry)}>
                                          <Td className="py-4">
                                             <Badge
                                                className={`px-3 py-1.5 rounded-lg font-bold border-2 transition-all duration-200 ${isDark
                                                   ? 'bg-purple-900/30 text-purple-300 border-purple-700/50 group-hover:shadow-lg group-hover:shadow-purple-900/30'
                                                   : 'bg-purple-50 text-purple-700 border-purple-300/50 group-hover:shadow-md group-hover:shadow-purple-200/50'
                                                   }`}>
                                                {entry.serialNo}
                                             </Badge>
                                          </Td>
                                          <Td className={`py-4 ${isDark ? 'text-gray-200 group-hover:text-purple-300' : 'text-gray-900 group-hover:text-purple-700'}`}>
                                             {entry.docno}
                                          </Td>
                                          <Td className={`py-4 ${isDark ? 'text-gray-200 group-hover:text-purple-300' : 'text-gray-900 group-hover:text-purple-700'}`}>
                                             {new Date(entry.transactionAt).toLocaleDateString('en-GB')}
                                          </Td>
                                          <Td className={`py-4 ${isDark ? 'text-gray-200 group-hover:text-purple-300' : 'text-gray-900 group-hover:text-purple-700'}`}>
                                             {entry.daybookName}
                                          </Td>
                                          <Td className={`py-4 ${isDark ? 'text-gray-200 group-hover:text-purple-300' : 'text-gray-900 group-hover:text-purple-700'}`}>
                                             {entry.accountName}
                                          </Td>
                                          <Td
                                             className={`font-semibold py-4 transition-colors ${isDark
                                                ? 'text-gray-200 group-hover:text-purple-300'
                                                : 'text-gray-900 group-hover:text-purple-700'
                                                }`}>
                                             {entry.ItemName}
                                          </Td>
                                          <Td
                                             className={`font-bold py-4 ${isDark ? 'text-green-400' : 'text-green-600'
                                                }`}>
                                             {entry.itemRate}
                                          </Td>
                                          <Td
                                             className={`font-bold py-4 ${isDark ? 'text-green-400' : 'text-green-600'
                                                }`}>
                                             {entry.type}
                                          </Td>
                                          <Td className="py-4">
                                             <Button
                                                size="sm"
                                                className={`rounded-xl font-semibold transition-all duration-300 border-2 ${isDark
                                                   ? 'bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white border-purple-500/50 shadow-lg shadow-purple-900/30'
                                                   : 'bg-gradient-to-r from-purple-500 to-blue-500 hover:from-purple-600 hover:to-blue-600 text-white border-purple-400/50 shadow-md shadow-purple-200/50'
                                                   } hover:shadow-xl hover:scale-105 px-6 py-2`}
                                                onClick={(e) => {
                                                   e.stopPropagation();
                                                   // await setSelectedEntry(entry);
                                                   // await setFormData({
                                                   //    warranty: entry.specifications ? entry.specifications.warranty : '',
                                                   //    conditions: entry.specifications ? entry.specifications.conditions : '',
                                                   //    salesRate: entry.specifications ? entry.specifications.salesRate : '',
                                                   //    battery: entry.specifications ? entry.specifications.battery : '',
                                                   //    notes: entry.specifications ? entry.specifications.notes : '',
                                                   //    notes2: entry.specifications ? entry.specifications.notes2 : '',
                                                   // });
                                                   // await handleBarcodePrint();
                                                   handleEntryClick(entry, "print");
                                                }}>
                                                <Printer className="w-4 h-4" />
                                             </Button>
                                          </Td>
                                       </Tr>
                                    ))}
                                 </Tbody>
                              </Table>
                           </div>
                        </div>
                     ) : (
                        <div
                           className={`rounded-2xl border-2 border-dashed ${isDark ? 'border-gray-700 bg-gray-800/50' : 'border-gray-300 bg-gray-50'
                              } py-16 text-center transition-all duration-300`}>
                           <div className="flex flex-col items-center justify-center space-y-4">
                              <div
                                 className={`p-4 rounded-2xl ${isDark
                                    ? 'bg-gray-700/50 border-2 border-gray-600'
                                    : 'bg-white border-2 border-gray-200 shadow-md'
                                    }`}>
                                 <Search className={`w-12 h-12 ${isDark ? 'text-gray-500' : 'text-gray-400'}`} />
                              </div>
                              <Text className={`text-xl font-bold ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                                 {searchQuery ? 'No entries found' : 'Enter serial number to search'}
                              </Text>
                              <Text className={`text-sm ${isDark ? 'text-gray-500' : 'text-gray-500'}`}>
                                 {searchQuery ? 'Try a different serial number' : 'Start typing to see results'}
                              </Text>
                           </div>
                        </div>
                     )}
                  </VStack>
               </ModalBody>
               <Modal isOpen={isFormOpen} onClose={onFormClose} size="4xl">
                  <ModalOverlay className="backdrop-blur-md bg-black/70" />
                  <ModalContent
                     className={`rounded-2xl shadow-2xl border-2 transition-all duration-300 ${isDark
                        ? 'bg-gray-800/95 backdrop-blur-xl border-gray-700/50'
                        : 'bg-white/95 backdrop-blur-xl border-gray-200/50'
                        }`}>
                     <ModalHeader
                        className={`rounded-t-2xl border-b-2 ${isDark
                           ? 'bg-gradient-to-r from-emerald-900/50 to-teal-900/50 border-emerald-800/40 text-white'
                           : 'bg-gradient-to-r from-emerald-50 to-teal-50 border-emerald-200/60 text-gray-900'
                           } py-6 px-8`}>
                        <div className="flex items-center gap-4">
                           <div
                              className={`p-3 rounded-xl transition-all duration-300 ${isDark
                                 ? 'bg-gradient-to-br from-emerald-900/50 to-teal-900/40 border-2 border-emerald-700/50 shadow-lg shadow-emerald-900/30'
                                 : 'bg-gradient-to-br from-emerald-50 to-teal-50 border-2 border-emerald-300/50 shadow-md shadow-emerald-200/50'
                                 }`}>
                              <FileText className={`w-6 h-6 ${isDark ? 'text-emerald-400' : 'text-emerald-600'}`} />
                           </div>
                           <div className="flex-1">
                              <Text className={`text-2xl font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>
                                 Warranty Details
                              </Text>
                              {selectedEntry && (
                                 <div
                                    className={`flex items-center gap-2 mt-1 text-sm ${isDark ? 'text-emerald-300' : 'text-emerald-700'
                                       }`}>
                                    <Package className="w-4 h-4" />
                                    <span className="font-semibold">
                                       {selectedEntry.serialNo} - {selectedEntry.ItemName}
                                    </span>
                                 </div>
                              )}
                           </div>
                        </div>
                     </ModalHeader>
                     <ModalCloseButton
                        className={`rounded-xl transition-all duration-300 hover:scale-110 ${isDark ? 'text-gray-400 hover:bg-gray-700/70' : 'text-gray-600 hover:bg-gray-100'
                           }`}
                     />
                     <ModalBody className="py-8 px-8">
                        <VStack spacing={6} align="stretch">
                           <div>
                              <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                                 {company?.shortName && company?.shortName !== "null" && (
                                    <Box
                                       className={`
                                    ${isDark
                                             ? 'bg-slate-900/50 border border-slate-700 hover:bg-slate-900'
                                             : 'bg-gray-50 border border-gray-200 hover:bg-gray-100'
                                          } 
                                    rounded-xl p-4 transition-all duration-200
                                 `}>
                                       <Checkbox
                                          isChecked={formData.showcompanyName}
                                          onChange={(e) => handleInputChange('showcompanyName', e.target.checked)}
                                          colorScheme="green"
                                          className={isDark ? 'text-slate-300' : 'text-gray-700'}>
                                          Show Company Name
                                       </Checkbox>
                                    </Box>
                                 )}
                                 <Box
                                    className={`
                                       ${isDark
                                          ? 'bg-slate-900/50 border border-slate-700 hover:bg-slate-900'
                                          : 'bg-gray-50 border border-gray-200 hover:bg-gray-100'
                                       } 
                                       rounded-xl p-4 transition-all duration-200
                                    `}>
                                    <Checkbox
                                       isChecked={formData.showitemName}
                                       onChange={(e) => handleInputChange('showitemName', e.target.checked)}
                                       colorScheme="green"
                                       className={isDark ? 'text-slate-300' : 'text-gray-700'}>
                                       Show Item Name
                                    </Checkbox>
                                 </Box>
                              </Grid>
                           </div>
                           <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                              {formData.showitemName && (
                                 <FormControl>
                                    <FormLabel
                                       className={`font-bold text-sm mb-3 uppercase tracking-wider ${isDark ? 'text-emerald-400' : 'text-emerald-700'
                                          }`}
                                    >
                                       Item Name
                                    </FormLabel>
                                    <div className="flex flex-col gap-2">
                                       <Input
                                          placeholder="Enter item name"
                                          value={formData.itemName}
                                          maxLength={35}
                                          onChange={(e) => {
                                             const value = e.target.value;
                                             if (value.length <= 35) {
                                                handleInputChange('itemName', value);
                                             }
                                          }}
                                          className={`rounded-xl border-2 transition-all duration-300 ${isDark
                                             ? 'border-gray-600/80 placeholder-gray-400 hover:border-emerald-500/70 focus:border-emerald-500/70 focus:ring-4 focus:ring-emerald-900/30'
                                             : 'border-gray-300 placeholder-gray-500 hover:border-emerald-400/70 focus:border-emerald-500/70 focus:ring-4 focus:ring-emerald-200/50 shadow-sm'
                                             } py-3 text-base focus:outline-none`}
                                       />
                                       {formData.itemName.length >= 35 && (
                                          <p className="text-red-500 text-xs font-medium">
                                             Maximum 35 characters allowed — you can’t enter more now.
                                          </p>
                                       )}
                                    </div>
                                 </FormControl>
                              )}
                              <FormControl>
                                 <FormLabel
                                    className={`font-bold text-sm mb-3 uppercase tracking-wider ${isDark ? "text-emerald-400" : "text-emerald-700"
                                       }`}
                                 >
                                    WARRANTY
                                 </FormLabel>

                                 <div className="flex items-center gap-3">
                                    <Input
                                       placeholder="Enter warranty period (e.g., 1 Year)"
                                       value={formData.warranty}
                                       onChange={(e) => handleInputChange("warranty", e.target.value)}
                                       style={{
                                          // backgroundColor: formData.color || (isDark ? "#1f2937" : "#ffffff"),
                                          color: formData.warrantyColor,
                                       }}
                                       className={`rounded-xl border-2 transition-all duration-300 ${isDark
                                          ? "border-gray-600/80 placeholder-gray-400 hover:border-emerald-500/70 focus:border-emerald-500/70 focus:ring-4 focus:ring-emerald-900/30"
                                          : "border-gray-300 placeholder-gray-500 hover:border-emerald-400/70 focus:border-emerald-500/70 focus:ring-4 focus:ring-emerald-200/50 shadow-sm"
                                          } py-3 text-base focus:outline-none`}
                                    />
                                    <input
                                       type="color"
                                       value={formData.warrantyColor || "#000000"}
                                       onChange={(e) => handleInputChange("warrantyColor", e.target.value)}
                                       className="w-12 h-12 cursor-pointer rounded-lg border-none bg-transparent transition-transform hover:scale-110 focus:outline-none"
                                    />
                                 </div>
                              </FormControl>
                              <FormControl>
                                 <FormLabel
                                    className={`font-bold text-sm mb-3 uppercase tracking-wider ${isDark ? 'text-emerald-400' : 'text-emerald-700'
                                       }`}>
                                    BATTERY
                                 </FormLabel>
                                 <div className="flex items-center gap-3">
                                    <Input
                                       placeholder="Enter battery warranty details"
                                       value={formData.battery}
                                       onChange={(e) => handleInputChange('battery', e.target.value)}
                                       style={{
                                          // backgroundColor: formData.color || (isDark ? "#1f2937" : "#ffffff"),
                                          color: formData.batteryColor,
                                       }}
                                       className={`rounded-xl border-2 transition-all duration-300 ${isDark
                                          ? "border-gray-600/80 placeholder-gray-400 hover:border-emerald-500/70 focus:border-emerald-500/70 focus:ring-4 focus:ring-emerald-900/30"
                                          : "border-gray-300 placeholder-gray-500 hover:border-emerald-400/70 focus:border-emerald-500/70 focus:ring-4 focus:ring-emerald-200/50 shadow-sm"
                                          } py-3 text-base focus:outline-none`}
                                    />
                                    <input
                                       type="color"
                                       value={formData.batteryColor || "#000000"}
                                       onChange={(e) => handleInputChange("batteryColor", e.target.value)}
                                       className="w-12 h-12 cursor-pointer rounded-lg border-none bg-transparent transition-transform hover:scale-110 focus:outline-none"
                                    />
                                 </div>
                              </FormControl>
                              <FormControl>
                                 <FormLabel
                                    className={`font-bold text-sm mb-3 uppercase tracking-wider ${isDark ? 'text-emerald-400' : 'text-emerald-700'
                                       }`}>
                                    CONDITIONS
                                 </FormLabel>
                                 <div className="flex items-center gap-3">
                                    <Input
                                       placeholder="Enter warranty conditions"
                                       value={formData.conditions}
                                       onChange={(e) => handleInputChange('conditions', e.target.value)}
                                       rows={3}
                                       style={{
                                          // backgroundColor: formData.color || (isDark ? "#1f2937" : "#ffffff"),
                                          color: formData.conditionsColor,
                                       }}
                                       className={`rounded-xl border-2 transition-all duration-300 ${isDark
                                          ? "border-gray-600/80 placeholder-gray-400 hover:border-emerald-500/70 focus:border-emerald-500/70 focus:ring-4 focus:ring-emerald-900/30"
                                          : "border-gray-300 placeholder-gray-500 hover:border-emerald-400/70 focus:border-emerald-500/70 focus:ring-4 focus:ring-emerald-200/50 shadow-sm"
                                          } py-3 text-base focus:outline-none`}
                                    />
                                    <input
                                       type="color"
                                       value={formData.conditionsColor || "#000000"}
                                       onChange={(e) => handleInputChange("conditionsColor", e.target.value)}
                                       className="w-12 h-12 cursor-pointer rounded-lg border-none bg-transparent transition-transform hover:scale-110 focus:outline-none"
                                    />
                                 </div>
                              </FormControl>
                              <FormControl>
                                 <FormLabel
                                    className={`font-bold text-sm mb-3 uppercase tracking-wider ${isDark ? 'text-emerald-400' : 'text-emerald-700'
                                       }`}>
                                    MRP
                                 </FormLabel>
                                 <div className="flex items-center gap-3">
                                    <Input
                                       placeholder="Enter MRP"
                                       value={formData.salesRate}
                                       onChange={(e) => handleInputChange('salesRate', e.target.value)}
                                       style={{
                                          // backgroundColor: formData.color || (isDark ? "#1f2937" : "#ffffff"),
                                          color: formData.salesRateColor,
                                       }}
                                       className={`rounded-xl border-2 transition-all duration-300 ${isDark
                                          ? "border-gray-600/80 placeholder-gray-400 hover:border-emerald-500/70 focus:border-emerald-500/70 focus:ring-4 focus:ring-emerald-900/30"
                                          : "border-gray-300 placeholder-gray-500 hover:border-emerald-400/70 focus:border-emerald-500/70 focus:ring-4 focus:ring-emerald-200/50 shadow-sm"
                                          } py-3 text-base focus:outline-none`}
                                    />
                                    <input
                                       type="color"
                                       value={formData.salesRateColor || "#000000"}
                                       onChange={(e) => handleInputChange("salesRateColor", e.target.value)}
                                       className="w-12 h-12 cursor-pointer rounded-lg border-none bg-transparent transition-transform hover:scale-110 focus:outline-none"
                                    />
                                 </div>
                              </FormControl>
                              <FormControl>
                                 <FormLabel
                                    className={`font-bold text-sm mb-3 uppercase tracking-wider ${isDark ? 'text-emerald-400' : 'text-emerald-700'
                                       }`}>
                                    Dealer Price
                                 </FormLabel>
                                 <div className="flex items-center gap-3">
                                    <Input
                                       placeholder="Enter Dealer Price"
                                       value={formData.dealerPrice}
                                       onChange={(e) => handleInputChange('dealerPrice', e.target.value)}
                                       className={`rounded-xl border-2 transition-all duration-300 ${isDark
                                          ? "border-gray-600/80 placeholder-gray-400 hover:border-emerald-500/70 focus:border-emerald-500/70 focus:ring-4 focus:ring-emerald-900/30"
                                          : "border-gray-300 placeholder-gray-500 hover:border-emerald-400/70 focus:border-emerald-500/70 focus:ring-4 focus:ring-emerald-200/50 shadow-sm"
                                          } py-3 text-base focus:outline-none`}
                                    />
                                 </div>
                              </FormControl>
                              <FormControl>
                                 <FormLabel
                                    className={`font-bold text-sm mb-3 uppercase tracking-wider ${isDark ? 'text-emerald-400' : 'text-emerald-700'
                                       }`}>
                                    NOTES
                                 </FormLabel>
                                 <div className="flex items-center gap-3">
                                    <Textarea
                                       placeholder="Enter additional notes"
                                       value={formData.notes}
                                       onChange={(e) => handleInputChange('notes', e.target.value)}
                                       rows={1}
                                       style={{
                                          // backgroundColor: formData.color || (isDark ? "#1f2937" : "#ffffff"),
                                          color: formData.notesColor,
                                       }}
                                       className={`rounded-xl border-2 transition-all duration-300 ${isDark
                                          ? "border-gray-600/80 placeholder-gray-400 hover:border-emerald-500/70 focus:border-emerald-500/70 focus:ring-4 focus:ring-emerald-900/30"
                                          : "border-gray-300 placeholder-gray-500 hover:border-emerald-400/70 focus:border-emerald-500/70 focus:ring-4 focus:ring-emerald-200/50 shadow-sm"
                                          } py-3 text-base focus:outline-none`}
                                    />
                                    <input
                                       type="color"
                                       value={formData.notesColor || "#000000"}
                                       onChange={(e) => handleInputChange("notesColor", e.target.value)}
                                       className="w-12 h-12 cursor-pointer rounded-lg border-none bg-transparent transition-transform hover:scale-110 focus:outline-none"
                                    />
                                 </div>
                              </FormControl>
                              <FormControl>
                                 <FormLabel
                                    className={`font-bold text-sm mb-3 uppercase tracking-wider ${isDark ? 'text-emerald-400' : 'text-emerald-700'
                                       }`}>
                                    NOTES 2
                                 </FormLabel>
                                 <div className="flex items-center gap-3">
                                    <Textarea
                                       placeholder="Enter more notes"
                                       value={formData.notes2}
                                       onChange={(e) => handleInputChange('notes2', e.target.value)}
                                       rows={1}
                                       style={{
                                          // backgroundColor: formData.color || (isDark ? "#1f2937" : "#ffffff"),
                                          color: formData.notes2Color,
                                       }}
                                       className={`rounded-xl border-2 transition-all duration-300 ${isDark
                                          ? "border-gray-600/80 placeholder-gray-400 hover:border-emerald-500/70 focus:border-emerald-500/70 focus:ring-4 focus:ring-emerald-900/30"
                                          : "border-gray-300 placeholder-gray-500 hover:border-emerald-400/70 focus:border-emerald-500/70 focus:ring-4 focus:ring-emerald-200/50 shadow-sm"
                                          } py-3 text-base focus:outline-none`}
                                    />
                                    <input
                                       type="color"
                                       value={formData.notes2Color || "#000000"}
                                       onChange={(e) => handleInputChange("notes2Color", e.target.value)}
                                       className="w-12 h-12 cursor-pointer rounded-lg border-none bg-transparent transition-transform hover:scale-110 focus:outline-none"
                                    />
                                 </div>
                              </FormControl>
                              <FormControl>
                                 <FormLabel
                                    className={`font-bold text-sm mb-3 uppercase tracking-wider ${isDark ? 'text-emerald-400' : 'text-emerald-700'
                                       }`}>
                                    NOTES 3
                                 </FormLabel>
                                 <div className="flex items-center gap-3">
                                    <Textarea
                                       placeholder="Enter more notes"
                                       value={formData.notes3}
                                       onChange={(e) => handleInputChange('notes3', e.target.value)}
                                       rows={1}
                                       style={{
                                          // backgroundColor: formData.color || (isDark ? "#1f2937" : "#ffffff"),
                                          color: formData.notes3Color,
                                       }}
                                       className={`rounded-xl border-2 transition-all duration-300 ${isDark
                                          ? "border-gray-600/80 placeholder-gray-400 hover:border-emerald-500/70 focus:border-emerald-500/70 focus:ring-4 focus:ring-emerald-900/30"
                                          : "border-gray-300 placeholder-gray-500 hover:border-emerald-400/70 focus:border-emerald-500/70 focus:ring-4 focus:ring-emerald-200/50 shadow-sm"
                                          } py-3 text-base focus:outline-none`}
                                    />
                                    <input
                                       type="color"
                                       value={formData.notes3Color || "#000000"}
                                       onChange={(e) => handleInputChange("notes3Color", e.target.value)}
                                       className="w-12 h-12 cursor-pointer rounded-lg border-none bg-transparent transition-transform hover:scale-110 focus:outline-none"
                                    />
                                 </div>
                              </FormControl>
                           </div>
                           <div className={`my-0 border-t-2 ${isDark ? 'border-gray-700/50' : 'border-gray-200/50'}`} />
                           <div className="flex flex-col sm:flex-row justify-end gap-3">
                              <Button
                                 ref={cancelRef}
                                 onClick={handleCancel}
                                 onKeyDown={(e) => {
                                    if (e.key === 'ArrowRight') {
                                       e.preventDefault();
                                       saveRef.current?.focus();
                                    }
                                 }}
                                 _focus={{ outlineColor: 'blue.500 ' }}
                                 className={`rounded-xl font-semibold py-3 px-8 transition-all duration-300 border-2 ${isDark
                                    ? 'bg-gray-700/50 hover:bg-gray-700 text-gray-200 border-gray-600/50 hover:border-gray-600 shadow-lg'
                                    : 'bg-white hover:bg-gray-50 text-gray-700 border-gray-300 hover:border-gray-400 shadow-md hover:shadow-lg'
                                    } hover:scale-105`}>
                                 Cancel
                              </Button>
                              <Button
                                 ref={saveRef}
                                 onClick={handleSave}
                                 onKeyDown={(e) => {
                                    if (e.key === 'ArrowLeft') {
                                       e.preventDefault();
                                       cancelRef.current?.focus();
                                    } else if (e.key === 'ArrowRight') {
                                       e.preventDefault();
                                       printRef.current?.focus();
                                    }
                                 }}
                                 _focus={{ outlineColor: 'blue.500 ' }}
                                 className={`rounded-xl font-semibold py-3 px-8 transition-all duration-300 border-2 ${isDark
                                    ? 'bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white border-green-500/50 shadow-lg shadow-green-900/30'
                                    : 'bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 text-white border-green-400/50 shadow-md shadow-green-200/50'
                                    } hover:shadow-xl hover:scale-105`}>
                                 Save
                              </Button>
                              <Button
                                 ref={printRef}
                                 onClick={handleBarcodePrint}
                                 onKeyDown={(e) => {
                                    if (e.key === 'ArrowLeft') {
                                       e.preventDefault();
                                       saveRef.current?.focus();
                                    } else if (e.key === 'ArrowRight') {
                                       e.preventDefault();
                                       saveNprintRef.current?.focus();
                                    }
                                 }}
                                 _focus={{ outlineColor: 'blue.500 ' }}
                                 className={`rounded-xl font-semibold py-3 px-8 transition-all duration-300 border-2 ${isDark
                                    ? 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white border-blue-500/50 shadow-lg shadow-blue-900/30'
                                    : 'bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 text-white border-blue-400/50 shadow-md shadow-blue-200/50'
                                    } hover:shadow-xl hover:scale-105`}>
                                 Print
                              </Button>
                              <Button
                                 ref={saveNprintRef}
                                 onClick={async () => {
                                    await handleSave("not close");
                                    await handleBarcodePrint();
                                 }}
                                 onKeyDown={(e) => {
                                    if (e.key === 'ArrowLeft') {
                                       e.preventDefault();
                                       printRef.current?.focus();
                                    }
                                 }}
                                 _focus={{ outlineColor: 'blue.500 ' }}
                                 className={`rounded-xl font-semibold py-3 px-8 transition-all duration-300 border-2 ${isDark
                                    ? 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white border-blue-500/50 shadow-lg shadow-blue-900/30'
                                    : 'bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 text-white border-blue-400/50 shadow-md shadow-blue-200/50'
                                    } hover:shadow-xl hover:scale-105`}>
                                 Save & Print
                              </Button>
                           </div>
                        </VStack>
                     </ModalBody>
                  </ModalContent>
               </Modal>
            </ModalContent>
         </Modal>
      </>
   );
}
